import {
  DESKTOP_BREAKPOINT,
  isTablet,
  getPageType,
  isRefferedPage,
  isGoogleDiscover,
  isDesktop,
  getDevice,
} from './config/device';
import { scaleAds } from './view/scaleAds';
import { pbjs } from './prebid/index';
import { resolveAdUnitPathGamSiteId, setDfpSection, isBlog, isTestSite, getVideoAdUnitPath } from './config/domain';
import {
  lazyloadSlot,
  refreshPrebidAd,
  getLoginId,
  isMainAndCategoryPage,
  isValidTargeting,
  isDebugTopAd,
} from './helpers/utils';
import amaLog, { amaWarn } from './helpers/log';
import { timeFor } from './helpers/time';
import { adsAbTest, getConnectionType } from './abtest/adsAbTest';
import { getGamVerticals } from './config/verticals';
import { getCookie } from './storage/cookies';
//////////////////////////////////////////////////
/////////////////////////////////////////////
/////////
/////////////////
///////////////////////////////////////////////
/////////

import { getModules } from './modules/index';
import adSettings from './config/adsettings';
import { resolveCountryCode } from './config/domain';
import adConfig, {
  modifyMainCategoryPlacementsDivs,
  withinTopScrollerLimit,
  findAdConfigForPlacement,
} from './config/adslots';
import TargetingManager from './helpers/TargetingManager';
import { updateMultivideoAdTagUrl } from './config/adschedule';
/////////////////
////////
/////////////////
/////////////////////////
////////////////
/////////////////////
///////////////
///////////////////
/////////////////////////////
////////////////////////////
/////////

import { useTopAds } from './config/platform';

export type InitManagerParams = {
  adsConfig?: IAdsConfig;
  _ppId?: string | undefined;
  uniqueId?: string;
  divId?: string;
  dfpSection?: string | undefined;
  pageNo?: number;
  hasConsent?: boolean;
  videoOnly?: boolean;
  isSecondArticle?: boolean;
  placementLog?: Function;
  usePrebid?: boolean;
  pageReset?: boolean;
  firstLoad?: boolean;
};

/**
 * AdsManager will make life a tad easier for developers to deal
 * with ads as it can feel like a black magic most of the times.
 *
 * We construct and set up ad slots in this class so that the ads are
 * ready to send and receive information to and from Google DFP Ads.
 */
class AdsManager implements IAdsManager {
  public adUnitPath: string;
  public videoAdUnitPath: string;
  public Ads: IAdRaw[];
  public Ad: IAdRaw;
  public adsConfig: IAdsConfig;
  public AdUnits: object[];
  public PrebidAdUnits: object[];
  public listeners: IListener[];
  public uniqueId: string;
  public ppId: string | undefined;
  public pageSlots: { [key: string]: IAdRaw[] } = {};
  public adSlots: { [key: string]: IAdRaw } = {};
  public device: string;
  public usePrebid: boolean;
  public renderMargin: string;
  public firstLoad = true;
  private divId: string;
  private gLazyLoadEnabled: boolean = false;
  public hasConsent: boolean;
  public videoOnly: boolean;
  public isSecondArticle: boolean;
  public placementLog: Function;
  public explicitContent: boolean;
  public firstVideoAutoStart: boolean;
  public countryCode: string;
  public loginId: string | boolean | undefined;
  public hasVideoBidsForPage: number[] = [];
  public pageNo: number = 0;
  public processedDivIds: Set<string>;

  /**
   * Upon initialization we will prepare instance variables and also
   * bind class methods that we want to make accessible to the api.
   *
   * Also an interval is run immediately to make sure that once googletag
   * api is ready we will also take action.
   */

  // @ts-ignore
  init(params: InitManagerParams) {
    const {
      adsConfig,
      _ppId,
      uniqueId,
      dfpSection,
      pageNo,
      hasConsent,
      videoOnly,
      isSecondArticle,
      placementLog,
      usePrebid,
      pageReset,
    } = params;

    this.hasConsent = hasConsent;
    this.videoOnly = videoOnly;
    this.isSecondArticle = isSecondArticle;
    amaLog('init AdManager', params);

    if (this.firstLoad) {
      amaLog('init this.firstLoad pageNo: ', pageNo);

      this.adsConfig = typeof adsConfig !== 'undefined' ? adsConfig : this.adsConfig;
      this.Ads = this.adsConfig?.ads || [];
      this.hasConsent = typeof hasConsent !== 'undefined' ? hasConsent : this.hasConsent;
      this.ppId = typeof _ppId !== 'undefined' ? _ppId : this.ppId;
      this.usePrebid = typeof usePrebid !== 'undefined' ? usePrebid : this.usePrebid;
      this.countryCode = resolveCountryCode();
      this.placementLog = placementLog;
    }

    if (pageReset) {
      this.processedDivIds = new Set<string>();
      this.adsConfig.dfpSection = setDfpSection(dfpSection);
      this.adsConfig.gamSiteId = resolveAdUnitPathGamSiteId(this.adsConfig.gamSiteId);
      this.adUnitPath = `/${this.adsConfig.networkCode}/${this.adsConfig.gamSiteId}/${this.adsConfig.dfpSection}`;
      getVideoAdUnitPath(this.adsConfig, this.videoOnly, adSettings);
    }

    if (this.videoOnly) {
      this.initializeVideoPageAds(pageNo);
    } else {
      this.gptQueue(() => this.initializeAds(uniqueId, pageNo));
    }
  }

  public initConfig(params: InitManagerParams) {
    const { adsConfig, _ppId, dfpSection, hasConsent, videoOnly, placementLog, usePrebid, pageReset } = params;

    amaLog('initConfig AdManager ', params);

    this.hasConsent = typeof hasConsent !== 'undefined' ? hasConsent : this.hasConsent;
    this.videoOnly = videoOnly;
    this.usePrebid = typeof usePrebid !== 'undefined' ? usePrebid : this.usePrebid;
    this.ppId = typeof _ppId !== 'undefined' ? _ppId : this.ppId;
    this.countryCode = resolveCountryCode();
    this.placementLog = placementLog;

    this.adsConfig = typeof adsConfig !== 'undefined' ? adsConfig : this.adsConfig;
    this.Ads = this.adsConfig?.ads || [];
/////////////////////
/////////////////////////////////////////////////////
/////////////////////////////////
/////////////
    pageReset && this.resetConfigs(dfpSection);

    if (this.videoOnly) {
      this.initializeVideoPageAds();
    }
  }

  public initAd(params: InitManagerParams) {
    const { hasConsent, pageNo, isSecondArticle, divId, pageReset } = params;

    amaLog('initAd AdManager ', params);

    this.hasConsent = typeof hasConsent !== 'undefined' ? hasConsent : this.hasConsent;

    pageReset && this.resetConfigs();

    this.gptQueue(() => this.initializeAd(divId, pageNo, isSecondArticle));
  }

  private resetConfigs(dfpSection?: string) {
    this.processedDivIds = new Set<string>();
    this.adSlots = {};
    this.adsConfig.dfpSection = setDfpSection(dfpSection);
    this.adsConfig.gamSiteId = resolveAdUnitPathGamSiteId(this.adsConfig.gamSiteId);
    this.adUnitPath = `/${this.adsConfig.networkCode}/${this.adsConfig.gamSiteId}/${this.adsConfig.dfpSection}`;
    getVideoAdUnitPath(this.adsConfig, this.videoOnly, adSettings);
  }

  private initializeVideoPageAds(pageNo?: number): void {
    this.setupPage(pageNo);

    this.requestPrebidVideoBids(pageNo);
    this.initDone();
  }

  private initializeAd(divId: string, pageNo: number, isSecondArticle: boolean): void {
    // Using Observer Without UniqueId

    if (this.adSlots[divId]) {
      amaLog(`initializeAd ${divId} already initialized. Skipping...`);
      return;
    }

    amaLog('initializeAd for divId - ', divId, pageNo, this.adsConfig.dfpSection, this.adSlots[divId]);

    // Find matching ad config
    const adTarget = findAdConfigForPlacement(this.adsConfig, divId);

    if (adTarget) {
      this.adSlots[divId] = { ...adTarget, divId: divId };
      this.adsConfig.dfpSection; // <-- this line looks incomplete in your snippet

      this.setupPage(pageNo);
      const ad = this.setupAdSlot(this.adSlots[divId], pageNo, isSecondArticle);
      if (ad) {
        this.googleInitializeAdSlot(this.adSlots[divId]);

        // First, all slots Without LazyLoad will be loaded, then Lazyload will be enabled for the rest of the slots

        this.refreshAdWithOutLazyload(this.adSlots[divId], pageNo);
        this.loadGoogleLazyload();
        this.refreshAdWithLazyload(this.adSlots[divId], pageNo);
      }

      this.firstLoad && isTablet && scaleAds();

      if (!this.hasVideoBidsForPage[pageNo]) {
        this.hasVideoBidsForPage[pageNo] = 1;
        this.requestPrebidVideoBids(pageNo);
      }
    } else {
      amaWarn('init divId - placements divId not found in Config: ', divId);
    }
  }

  private initializeAds(adsUniqueId: string, pageNo: number): void {
    this.setupPage(pageNo);
    this.setupAdSlots(adsUniqueId, pageNo);

    this.googleInitializeAdSlots(adsUniqueId);

    this.refreshAdsWithOutLazyload(adsUniqueId, pageNo);
    this.loadGoogleLazyload();
    this.refreshAdsWithLazyload(adsUniqueId, pageNo);
    isTablet && scaleAds();
    this.requestPrebidVideoBids(pageNo);
    this.initDone();
  }

  private initDone(): void {
    this.firstLoad = false;
  }

  public invokeVideoPlayer(videoBidResult: any, bids: any) {
    amaLog(`DM requestVideoBids videoBidResult ${timeFor('prebidVidDone')} `, videoBidResult, bids);

    window.amaTagUrl = videoBidResult?.adTagUrl;
    window.ama.adsBids = bids;
  }

  public loadGoogleLazyload(): void {
    if (this.gLazyLoadEnabled) return;

    const { useGLazyLoad } = getModules();
    if (!useGLazyLoad) {
      this.gLazyLoadEnabled = true;
      return;
    }
    amaLog('useGLazyLoad ');

    const fetchMarginPercent = isDesktop()
      ? this.adsConfig.fetchMarginPercentDesk
      : this.adsConfig.fetchMarginPercentMob ?? 40;
    let renderMarginPercent = isDesktop()
      ? this.adsConfig.renderMarginPercentDesk
      : this.adsConfig.renderMarginPercentMob ?? 20;

    if (adsAbTest() === 'c') {
      const margins = [5, 10, 15, 20, 25, 30];
      if (!this.renderMargin) {
        this.renderMargin = margins[Math.floor(Math.random() * margins.length)].toString();
      }
      renderMarginPercent = parseInt(this.renderMargin);

      TargetingManager.setPageTargeting({
        lazyload: `c${this.renderMargin}`,
        RenderMargin: this.renderMargin,
        connectionRtt: getConnectionType(),
      });
    } else {
      TargetingManager.setPageTargeting({ lazyload: 'a' });
    }

    window.googletag.setConfig({
      lazyLoad: {
        fetchMarginPercent,
        renderMarginPercent,
      },
    });
    this.gLazyLoadEnabled = true;
  }

  public requestPrebidVideoBids(pageNo: number): void {
////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////
/////////////////
////////////////////////////////////////////////////////////////////
/////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////
//////////////////////
/////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////
/////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////
//////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////
///////////////////////////////////////////////
///////////////////////
///////////////
//////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////
//////////////////////////////
///////////////////////////////////
////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////

///////////////////////////////////////////
////////////////////////////////////////////////////////////
/////////////////////////
/////////////////

//////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////
///////////////////
//////////////////////////////////////////////
//////////////////////////////////////////
//////////////////

///////////////////////////////////////
////////////////////////////////////////
////////////////////////////////////////////////
/////////////////

//////////////////////////////////////////////
/////////////////////////////////////
///////////////////////////////////////
//////////////////
//////////////////////////////////////////////////////////////////////

////////////////////////////////////////
///////////////////////////
////////////////////////////////////
//////////////////////////////////////////////////////////////
////////////////////////////
////////////////////
///////////////////////////////////////////////
////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
////////////////////
//////////////////////////////////////////
/////////////////////////////////////////////////////
/////////////////////
////////////////
///////////////
///////////
/////////
/////////
/////
/////////////
  }

  /**
   * Queue
   *
   * Helps us push our functions to the google call stack and
   * keep our context.
   *
   * @param fn fn
   * @return void
   */
  public gptQueue(fn: Function): void {
    window.googletag.cmd.push(fn.bind(this));
  }

  /**
   * PrebidJS Queue
   *
   * Helps us push functions to the prebid call stack and keep
   * our context.
   *
   * @param fn fn
   *
   * @return void
   */
  public dmQueue(fn: Function): void {
    pbjs.que.push(() => fn.apply(this));
  }

  /**
   * This method setup ad-settings on a page-level. For instance it
   * iterates window.aller_ga.verticals object and targets verticals
   * that is common for all ads
   * @return void
   */
  private setupPage(pageNo: number): void {
    if (pageNo > 1) return;

    this.gptQueue(() => {
      this.device = getDevice();

      const verticals = getGamVerticals(this.adsConfig.verticals);
      const pageTargeting: Record<string, string | string[]> = {
        hour: new Date().getHours().toString(),
        page: adSettings.explicitContent?.toString() === 'true' ? 'explicit' : getPageType(),
        consent: this.hasConsent ? 'yes' : 'no',
      };

      if (isTestSite()) pageTargeting.stage = 'true';
////////////////////////////////////////////////////////
      pageTargeting['Vertikal'] = verticals ?? '';
///////////////

      const pathComponents = window.location.pathname.split('/');
      pageTargeting.url = window.location.hostname;
      pathComponents[1] && (pageTargeting['url-category'] = pathComponents[1]);
      pathComponents[2] && (pageTargeting['url-content'] = pathComponents[2]);

      isRefferedPage() && (pageTargeting['user-agent'] = 'search');
      isGoogleDiscover() && (pageTargeting['user-agent'] = 'discover');

      const loginCookie = getCookie('login_token');
      loginCookie && (pageTargeting.page = 'login');
      isBlog() && (pageTargeting.page = 'blog');

      // window.ama?.pageTargets will override
      Object.entries(window.ama?.pageTargets || {}).forEach(([key, value]) => {
        if (isValidTargeting({ key, value }) && key !== 'page_type') {
          pageTargeting[key] = value;
        }
      });
      if (this.hasConsent && this.ppId) {
        window.googletag.pubads().setPublisherProvidedId(this.ppId);
      }

      // Norway spesific targeting
///////////////////////
///////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////

/////////////////////////
/////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
///////

//////////////////////////////////////////
/////////////////////////////////////////////////////////
//////////////////////////////////////////////
////////////////////////////////////////////
////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////
/////////
///////

/////////////////////////////////////////////////
///////////////////////////////////////////////////////
////////////////////////////////////////////////////
/////////

//////////////////////////////////////////////////////////////////
/////////////////////////////

///////////////

      window.googletag.setConfig({
        targeting: pageTargeting,
      });
    });
  }

  private setupAdSlot = (ad: IAdRaw, pageNo: number, isSecondArticle: boolean): IAdRaw => {
    // Define the slot if a corresponding html node is found
    const domId = ad.divId;
    const showTopAd = (useTopAds() && withinTopScrollerLimit()) || isDebugTopAd();
    if (ad.target === 'top_ad' && !showTopAd) {
      amaLog(`Top ad ${domId} is not eligible to be shown.`);
      return ad;
    }
    this.loginId ??= getLoginId() || false;

//////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////
/////////////

    ad.adSlot = window.googletag.defineSlot(this.adUnitPath, [...ad.sizes?.mobile, ...ad.sizes?.desktop], domId);

    const mapping = window.googletag
      .sizeMapping()
      .addSize([0, 0], ad.sizes.mobile)
      .addSize(DESKTOP_BREAKPOINT, ad.sizes.desktop)
      .build();
    ad.adSlot.defineSizeMapping(mapping).addService(window.googletag.pubads());

    if (this.countryCode === 'no') {
      TargetingManager.setSlotTargeting(ad.adSlot, { pos: ad.placement.slice(3) });
    } else {
      TargetingManager.setSlotTargeting(ad.adSlot, { pos: ad.placement });
    }

    if (isSecondArticle && pageNo === 2 && ad.target !== 'top_ad')
      TargetingManager.setSlotTargeting(ad.adSlot, { secondarticle: 'true' });
    this.loginId && TargetingManager.setSlotTargeting(ad.adSlot, { loginid: this.loginId.toString() });
    this.usePrebid && TargetingManager.setSlotTargeting(ad.adSlot, { demandmanager: '1' });
/////////////////////
//////////////////////////////////////////////////////////////////////////////////
/////////////

/////////////////////
//////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////
/////////////

    return ad;
  };

  /**
   * Uses data from the back-end, ACC
   *
   * This method iterates through each ad and runs checks to see what sort
   * of ad we are dealing with and sets up size mapping and defines the
   * actual ad slot using the googletag api.
   *
   * @return void
   */
  private setupAdSlots(uniqueId: string, pageNo: number): void {
    const { useDivModificationsOnMainCat } = getModules();

    this.uniqueId = `-${uniqueId}`;

    useDivModificationsOnMainCat && isMainAndCategoryPage() && modifyMainCategoryPlacementsDivs(this.processedDivIds);

    amaLog(
      'setupAdSlots useDivModificationsOnMainCat, isMainAndCategoryPage(), proccessed',
      useDivModificationsOnMainCat,
      isMainAndCategoryPage(),
      this.processedDivIds,
    );

    let config = adConfig.getModifiedPlacements(this.adsConfig, pageNo);

    config = adConfig.addExtraPlacementsToConfig(config, 'intext');
    config = adConfig.addExtraPlacementsToConfig(config, 'responsive');

    const filteredAds: IAdRaw[] = (adSettings.filterAds ? adConfig.filter(config, adSettings.isNativeAd) : config).ads;

    amaLog(`filteredConfig ${timeFor('confLoad', 'stop')}`, filteredAds);

    this.gptQueue(() => {
      this.pageSlots[uniqueId] = filteredAds.map((ad) => this.setupAdSlot(ad, pageNo, this.isSecondArticle)) || [];
      this.placementLog(uniqueId);
      amaLog('setupAdSlots pageSlots uniqueId ', uniqueId, this.pageSlots[uniqueId], this.pageSlots);
    });
  }

  private googleInitializeAdSlot(ad: IAdRaw): void {
    this.gptQueue(() => {
      const adDiv = ad.divId ?? `${ad.target}${this.uniqueId}`;
      amaLog('googleInitializeAdSlot', adDiv);
      window.googletag.display(adDiv);
    });
  }

  /**
   * We iterate through each defined ad in our object DfpAds.Ads and run
   * the GPT method display() to initialize and define the ad placement, note.. we aren't loading them
   * yet.
   *
   * @return void
   */
  private googleInitializeAdSlots(uniqueId: string): void {
    this.gptQueue(() => {
      this.pageSlots[uniqueId].forEach((ad) => this.googleInitializeAdSlot(ad));
    });
  }

  public refreshAd(ad: IAdRaw): void {
    amaLog('refresh (load) Ad ', ad.adSlot?.getSlotElementId());

    if (this.usePrebid) {
      refreshPrebidAd(ad);
    } else {
      window.googletag.pubads().refresh([ad.adSlot], { changeCorrelator: false });
    }
  }
  public refreshAdWithOutLazyload(ad: IAdRaw, pageNo = 1): void {
    if (!lazyloadSlot(ad, pageNo)) {
      amaLog('refresh Ad WITHOUT Lazyload ', ad.adSlot?.getSlotElementId());

      this.refreshAd(ad);
    }
  }
  public refreshAdWithLazyload(ad: IAdRaw, pageNo = 1): void {
    if (lazyloadSlot(ad, pageNo)) {
      amaLog('refresh Ad WITH Lazyload ', ad.adSlot?.getSlotElementId());

      this.refreshAd(ad);
    }
  }

  public refreshAdsWithOutLazyload(uniqueId: string, pageNo = 1): void {
    this.gptQueue(() => {
      this.pageSlots[uniqueId].forEach((ad) => {
        this.refreshAdWithOutLazyload(ad, pageNo);
      });
    });
  }

  public refreshAdsWithLazyload(uniqueId: string, pageNo = 1): void {
    this.gptQueue(() => {
      this.pageSlots[uniqueId].forEach((ad) => {
        this.refreshAdWithLazyload(ad, pageNo);
      });
    });
  }
}

export default new AdsManager();
